import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router';
import { PageSizeSelect } from '@rossum/components/page-size-select/PageSizeSelect';
import { Pagination, Stack } from '@rossum/ui/material';
import { pageSizeOptions } from '../../../../constants/values';
import { asScalar, setQueryCreator } from '../../../../lib/url';

export type ListFooterProps = {
  listLength: number | undefined;
  totalPages: number | undefined;
};

const ListFooter = ({ listLength, totalPages }: ListFooterProps) => {
  const history = useHistory();
  const location = useLocation();
  const { page: currentPage, pageSize } = queryString.parse(location.search);

  const setQuery = setQueryCreator(history);

  return (
    <Stack
      sx={{
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        padding: '20px',
        position: 'relative',
        '& > *': {
          flex: '1 0 33%',
          '&:last-child': {
            display: 'flex',
            justifyContent: 'flex-end',
          },
        },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={3}>
        <PageSizeSelect
          options={pageSizeOptions}
          setPageSize={newPageSize =>
            setQuery({ pageSize: newPageSize, page: '1' })
          }
          pageSize={Number(asScalar(pageSize))}
        />
        {!!listLength && totalPages && (
          <Pagination
            page={Number(currentPage)}
            count={totalPages}
            onChange={(_, page: number) => setQuery({ page: `${page}` })}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default ListFooter;
